import React, {useState, useEffect} from "react";
import {Images} from "./index";


function NoData({type}) {

    return <div className="text-center">
            <Images src={require('../../images/info.png')} />
            <div>
                <h5 className="text-white text-center">No {type} data to display.</h5>
            </div>
        </div>

}

export default NoData;